/* Think Crucial product page v2 (templates/product.liquid tc_v2 branch, snippets/tc-v2-*.liquid).
   Layered on tc-pdp.js, which loads first and keeps doing the variant sync, quantity stepper, ajaxify-shop.js submit guard and
   dispatch clock. This file adds: the supply picker and discount-aware totals, the per-unit line, low stock and stock labels,
   the sticky bar (mobile and desktop), the final card button, the gallery and zoom, the model checker and the install video.
   It never adds to the cart itself: think-crucial.js InlineCart owns every add. No libraries. */
(function () {
  var root = document.querySelector('[data-tcp]');
  if (!root) { return; }
  var form = document.querySelector('form[data-tc-bb-form]');
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function money(c) {
    var p = (Math.round(c) / 100).toFixed(2).split('.');
    return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
  }

  /* The theme header is fixed: expose its height so the sticky gallery and #anchor jumps clear it. */
  var hdrRaf = 0;
  var headerBottom = function () {
    var h = document.querySelector('.tcs-hdr') || document.querySelector('header.banner') || document.querySelector('body > header');
    if (!h) { return 0; }
    var pos = window.getComputedStyle(h).position;
    if (pos !== 'fixed' && pos !== 'sticky') { return 0; }
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  };
  var headerOffset = function () {
    hdrRaf = 0;
    document.documentElement.style.setProperty('--tcp-top', headerBottom() + 'px');
  };
  headerOffset();
  window.addEventListener('load', headerOffset);
  window.addEventListener('resize', function () { if (!hdrRaf) { hdrRaf = requestAnimationFrame(headerOffset); } }, { passive: true });
  window.addEventListener('scroll', function () { if (!hdrRaf) { hdrRaf = requestAnimationFrame(headerOffset); } }, { passive: true });

  /* ---------- order ticket ---------- */
  if (form) {
    var cfg = json(form.querySelector('[data-tcp-cfg]')) || {};
    var variants = json(form.querySelector('[data-tc-variants]')) || [];
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });
    var qtyInput = form.querySelector('input[name="quantity"]');
    var mainBtn = form.querySelector('[data-tc-atc-main]');
    var mainLabel = form.querySelector('[data-tc-atc-label]');
    var stickyBtn = form.querySelector('[data-tc-atc-sticky]');
    var finalBtn = $('[data-tcp-final]');
    var finalLabel = $('[data-tcp-final-label]');

    var selected = function () {
      var r = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
      return (r && byId[r.value]) || variants[0];
    };
    var qty = function () {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return n > 0 ? Math.min(n, 99) : 1;
    };
    /* Same rounding as the cart: each unit loses floor(price x pct / 100) once the quantity reaches the break. */
    var unitPrice = function (v, q) {
      if (cfg.qmin > 1 && cfg.pct > 0 && q >= cfg.qmin) { return v.price - Math.floor(v.price * cfg.pct / 100); }
      return v.price;
    };
    var plural = function (n, one, many) { return n + ' ' + (n === 1 ? one : many); };
    var every = function (m) { return m === 1 ? 'month' : m + ' months'; };
    var perText = function (v) {
      if (cfg.mode === 'cleaner') {
        if (!(v.uses > 0)) { return ''; }
        var t = 'About <b>' + money(v.price / v.uses) + ' per use</b> · ' + v.uses + ' uses';
        if (cfg.months > 0) {
          var span = v.uses * cfg.months;
          t += span % 12 === 0 ? ' ≈ ' + plural(span / 12, 'year', 'years') + ' at one every ' + every(cfg.months) : ' ≈ ' + plural(span, 'month', 'months') + ' at one every ' + every(cfg.months);
        }
        return t;
      }
      if (v.units > 1) { return '<b>' + money(v.price / v.units) + ' each</b>'; }
      if (cfg.months > 0 && !(cfg.qmin > 1)) { return 'About <b>' + money(v.price / cfg.months) + ' a month</b> at ' + plural(cfg.months, 'month', 'months') + ' per ' + cfg.noun; }
      return '';
    };

    var render = function () {
      var v = selected();
      if (!v) { return; }
      var q = qty();
      var total = unitPrice(v, q) * q;
      var label = v.available ? 'Add ' + (q > 1 ? q + ' ' : '') + 'to cart — ' + money(total) : 'Sold out';
      if (mainLabel) { mainLabel.textContent = label; }
      if (finalLabel) { finalLabel.textContent = label; }
      if (finalBtn) { finalBtn.disabled = !v.available; }
      [mainBtn, stickyBtn].forEach(function (b) {
        if (!b) { return; }
        b.setAttribute('data-variant-id', v.id);
        b.setAttribute('data-variant-qty', q);
        b.disabled = !v.available;
      });
      $$('[data-tcp-total]').forEach(function (el) { el.textContent = money(total); });
      $$('[data-tcp-per]').forEach(function (el) { var t = perText(v); el.innerHTML = t; el.hidden = !t; });
      $$('[data-tcp-low]').forEach(function (el) { el.textContent = v.low > 0 ? 'Only ' + v.low + ' left' : ''; el.hidden = !(v.low > 0); });
      $$('[data-tcp-stock]').forEach(function (el) { el.classList.toggle('is-out', !v.available); });
      $$('[data-tcp-stock-t],[data-tcp-stock-m]').forEach(function (el) { el.textContent = v.available ? 'In stock' : 'Sold out'; });
      $$('[data-tcp-stock-m]').forEach(function (el) { el.classList.toggle('is-out', !v.available); });
      if (stickyBtn) { stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    };

    var pickPlan = function (n, focus) {
      var r = form.querySelector('input[name="tcp_plan"][value="' + n + '"]');
      if (!r) { return false; }
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
      if (focus) { try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } }
      return true;
    };

    /* Registered after tc-pdp.js's own listeners on the same form, so these run second and own the labels. */
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'tcp_plan' && qtyInput) { qtyInput.value = t.value; }
      if (t.name === 'id') { showImageFor(selected()); }
      render();
    });
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-tc-step]')) { render(); }
    });
    if (qtyInput) { qtyInput.addEventListener('input', render); }
    window.addEventListener('pageshow', function () {
      var r = form.querySelector('input[name="tcp_plan"]:checked');
      if (r && qtyInput) { qtyInput.value = r.value; }
      render();
    });

    $$('[data-tcp-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (pickPlan(b.getAttribute('data-tcp-pick'), true)) {
          var t = $('#tcp-buy');
          if (t) { t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); }
        }
      });
    });

    /* Sticky bar: on whenever neither the main button nor the final card's button is fully visible in the part of the viewport the
       header doesn't cover. Header C is sticky and hides on scroll down / returns on scroll up, so its height is re-read on
       every check instead of being fixed into an IntersectionObserver rootMargin. */
    var sticky = $('[data-tcp-sticky]');
    if (sticky && mainBtn) {
      var stickyRaf = 0;
      var visibleBelowHeader = function (el) {
        if (!el) { return false; }
        var r = el.getBoundingClientRect();
        if (!r.width && !r.height) { return false; }
        /* Fully visible below the header and above the bottom edge; a button the sticky bar would cover counts as hidden
           (2026-10-27: the bar no longer draws over a button that is already fully on screen). */
        return r.top >= headerBottom() + 4 && r.bottom <= window.innerHeight;
      };
      var setSticky = function () {
        stickyRaf = 0;
        var on = !visibleBelowHeader(mainBtn) && !visibleBelowHeader(finalBtn);
        if (sticky.classList.contains('is-on') === on) { return; }
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyBtn) { stickyBtn.tabIndex = on ? 0 : -1; }
        document.documentElement.classList.toggle('tcp-sticky-on', on);
      };
      var queueSticky = function () { if (!stickyRaf) { stickyRaf = requestAnimationFrame(setSticky); } };
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky, { passive: true });
      window.addEventListener('load', queueSticky);
      setTimeout(queueSticky, 400);
      setSticky();
    }

    /* Which button added: main, sticky or the final card. Shopify.analytics tc_atc_click; the add itself stays with InlineCart. */
    [[mainBtn, 'main'], [stickyBtn, 'sticky'], [finalBtn, 'final']].forEach(function (p) {
      if (!p[0]) { return; }
      p[0].addEventListener('click', function () {
        var v = selected();
        try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { Shopify.analytics.publish('tc_atc_click', { source: p[1], variant: v ? v.id : null, qty: qty(), y: Math.round(window.scrollY) }); } } catch (e) {}
      });
    });

    render();
  }

  /* ---------- gallery ---------- */
  var gal = $('[data-tcp-gal]');
  var track = gal && $('[data-tcp-track]', gal);
  var slides = track ? $$('[data-tcp-slide]', track) : [];
  var thumbs = gal ? $$('[data-tcp-thumb]', gal) : [];
  var figEl = gal && $('[data-tcp-fig]', gal);
  var current = 1;
  function setCurrent(i) {
    current = i;
    thumbs.forEach(function (t) {
      var on = +t.getAttribute('data-tcp-thumb') === i;
      t.classList.toggle('is-on', on);
      if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
    });
    if (figEl) { figEl.textContent = (i < 10 ? '0' : '') + i; }
  }
  function goTo(i, smooth) {
    var s = slides[i - 1];
    if (!s || !track) { return; }
    track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
    setCurrent(i);
  }
  function showImageFor(v) {
    if (!v || !v.image) { return; }
    slides.forEach(function (s, k) { if (+s.getAttribute('data-image-id') === v.image) { goTo(k + 1, true); } });
  }
  if (track && slides.length) {
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-tcp-thumb'), true); }); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) { return; }
      raf = requestAnimationFrame(function () {
        raf = 0;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1;
        if (i !== current && i >= 1 && i <= slides.length) { setCurrent(i); }
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' && current < slides.length) { e.preventDefault(); goTo(current + 1, true); }
      if (e.key === 'ArrowLeft' && current > 1) { e.preventDefault(); goTo(current - 1, true); }
    });

    var dlg = $('[data-tcp-zoomdlg]', gal);
    var zimg = dlg && $('[data-tcp-zoomimg]', dlg);
    var stage = dlg && $('[data-tcp-zoomstage]', dlg);
    var zk = dlg && $('[data-tcp-zoomk]', dlg);
    var opener = null;
    if (dlg && typeof dlg.showModal === 'function') {
      $$('[data-tcp-zoom]', track).forEach(function (b, k) {
        b.addEventListener('click', function () {
          opener = b;
          var im = b.querySelector('img');
          zimg.src = b.getAttribute('data-tcp-zoom');
          zimg.alt = im ? im.alt : '';
          if (zk) { zk.textContent = 'Fig. ' + (k < 9 ? '0' : '') + (k + 1) + ' of ' + slides.length; }
          stage.classList.remove('is-zoomed');
          dlg.showModal();
        });
      });
      stage.addEventListener('click', function (e) {
        if (e.target !== zimg) { dlg.close(); return; }
        var r = zimg.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        stage.classList.toggle('is-zoomed');
        if (stage.classList.contains('is-zoomed')) {
          stage.scrollLeft = fx * stage.scrollWidth - stage.clientWidth / 2;
          stage.scrollTop = fy * stage.scrollHeight - stage.clientHeight / 2;
        }
      });
      $('[data-tcp-zoomx]', dlg).addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('close', function () { if (opener) { opener.focus(); } });
    } else {
      $$('[data-tcp-zoom]', track).forEach(function (b) {
        b.addEventListener('click', function () { window.open(b.getAttribute('data-tcp-zoom'), '_blank', 'noopener'); });
      });
    }
  }

  /* ---------- model checker: exact matches only, never a near match ---------- */
  var chk = $('[data-tcp-chk]');
  var data = json($('[data-tcp-models]') || { textContent: 'null' });
  if (chk && data) {
    var input = $('[data-tcp-chkin]');
    var out = $('#tcp-chk-out');
    var norm = function (s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); };
    var B = norm(data.brand);
    var stripBrand = function (n) { return B && n.indexOf(B) === 0 ? n.slice(B.length) : n; };
    var entries = (data.models || []).map(function (m) {
      var base = String(m.name).replace(/\s*\([^)]*\)\s*$/, '');
      var keys = [norm(m.name), stripBrand(norm(m.name)), norm(base), stripBrand(norm(base))];
      if (m.code) { keys.push(norm(m.code)); }
      return { label: m.name, code: m.code ? norm(m.code) : '', keys: keys.filter(Boolean), kind: 'model' };
    });
    (Array.isArray(data.parts) ? data.parts : []).forEach(function (p) { entries.push({ label: p, code: norm(p), keys: [norm(p)], kind: 'part' }); });
    var what = data.what || 'model';
    var line = function (cls, head, body) {
      out.className = 'tcp-result' + (cls ? ' ' + cls : '');
      out.textContent = '';
      var h = document.createElement('p'); h.className = 'tcp-result__h';
      var b = document.createElement('b'); b.textContent = head[0]; h.appendChild(b);
      if (head[1]) { h.appendChild(document.createTextNode(' ' + head[1])); }
      var p = document.createElement('p'); p.className = 'tcp-result__p';
      body.forEach(function (part) {
        if (typeof part === 'string') { p.appendChild(document.createTextNode(part)); }
        else { var a = document.createElement('a'); a.href = part.href; a.textContent = part.text; a.className = 'tcp-il'; p.appendChild(a); }
      });
      out.appendChild(h); out.appendChild(p);
    };
    /* No match here: ask the header search's exact-match lookup which products list the input, and link them (never this one). */
    var here = String(data.url || location.pathname).split('?')[0];
    var xlSeq = 0;
    var crosslink = function (raw) {
      var q = String(raw).trim();
      if (norm(q).length < 3) { return; }
      var seq = ++xlSeq;
      setTimeout(function () {
        var qs = 'q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&section_id=tc-suggest';
        fetch('/search/suggest?' + qs, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
          if (seq !== xlSeq || norm(input.value) !== norm(q)) { return; }
          var m = t && t.match(/<script type="application\/json" data-tc-suggest>([\s\S]*?)<\/script>/);
          var list = [];
          try { list = m ? JSON.parse(m[1]) : []; } catch (e) { list = []; }
          list = list.filter(function (p) { return p && p.fit && String(p.url || '').split('?')[0] !== here; });
          if (!list.length) { return; }
          var box = document.createElement('div'); box.className = 'tcp-xl';
          var h = document.createElement('p'); h.className = 'tcp-xl__h';
          h.textContent = list.length === 1 ? 'Not this one. ' + list[0].fit + ' takes:' : 'Not this one. These list ' + list[0].fit + ':';
          box.appendChild(h);
          var ul = document.createElement('ul');
          list.slice(0, 3).forEach(function (p) {
            var li = document.createElement('li');
            var a = document.createElement('a'); a.className = 'tcp-il'; a.href = String(p.url).split('?')[0]; a.textContent = p.dt || p.title;
            var s = document.createElement('span'); s.className = 'tcp-xl__m';
            s.textContent = ' · ' + (p.price_min !== p.price_max ? 'from ' : '') + money(p.price_min || p.price) + (p.available ? '' : ' · sold out');
            li.appendChild(a); li.appendChild(s); ul.appendChild(li);
          });
          box.appendChild(ul);
          if (list.length > 3) {
            var all = document.createElement('a'); all.className = 'tcp-il tcp-xl__all'; all.href = '/search?type=product&q=' + encodeURIComponent(q);
            all.textContent = 'See all ' + list.length + ' parts that list ' + q;
            box.appendChild(all);
          }
          out.appendChild(box);
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) { Shopify.analytics.publish('tc_fit_crosslink', { query: q, count: list.length }); } } catch (e) {}
        }).catch(function () {});
      }, 60);
    };
    var check = function (raw) {
      xlSeq++;
      var n = norm(raw);
      if (!n) { out.textContent = ''; out.className = 'tcp-result'; return; }
      var n2 = stripBrand(n);
      var hit = null;
      entries.forEach(function (e) {
        if (hit) { return; }
        if (e.keys.indexOf(n) > -1 || (n2 && e.keys.indexOf(n2) > -1)) { hit = e; return; }
        if (data.suffix && e.code && n2.indexOf(e.code) === 0 && /^[A-Z]+$/.test(n2.slice(e.code.length))) { hit = e; }
      });
      if (hit) {
        var verb = hit.kind === 'part' ? 'Replaces part ' : (data.mode === 'cleaner' ? 'Works with ' : 'Fits ');
        line('', ['✓ Listed', verb + hit.label], [data.mode === 'cleaner'
          ? 'This is listed for your machine. If it doesn’t work with it, email us and we refund it; you don’t need to send it back.'
          : 'This is listed for your model. If it doesn’t fit, we email a prepaid return label within 30 days of delivery and refund you in full.']);
      } else if (!n2) {
        line('is-no', ['Need the full model', ''], ['Type the model number or name exactly as it is printed on the label, not just the brand.']);
      } else {
        line('is-no', ['Not on our list', 'Compatibility not confirmed'], ['We haven’t confirmed this for “' + String(raw).trim().slice(0, 60) + '”. Email ', { href: 'mailto:support@thinkcrucial.com', text: 'support@thinkcrucial.com' }, ' with the ' + what + ' number from the label and we’ll tell you before you order.']);
        crosslink(raw);
      }
    };
    chk.addEventListener('submit', function (e) { e.preventDefault(); check(input.value); });
    $$('[data-tcp-try]').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-tcp-try]').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        input.value = t.getAttribute('data-tcp-try');
        check(input.value);
      });
    });
  }

  /* ---------- install video: the iframe loads only after the click ---------- */
  $$('[data-tcp-video]').forEach(function (box) {
    var btn = $('button', box);
    if (!btn) { return; }
    btn.addEventListener('click', function () {
      var id = box.getAttribute('data-tcp-video').replace(/[^A-Za-z0-9_-]/g, '');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&cc_load_policy=1&playsinline=1';
      f.title = box.getAttribute('data-tcp-video-title') || 'Install video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      box.replaceChild(f, btn);
      f.focus();
    });
  });
})();

/* Direction B buy box (P8, snippets/tc-p8-*.liquid; was assets/tc-p8.js): quote cards' "Read all", and the reassurance chips open their full text (one at a time).
   Without JS every panel is shown. The add to cart, sticky bar, stepper and gallery are tc-pdp.js / tc-pdp-v2.js, unchanged. */
(function () {
  /* Amazon quote cards: on phones a long quote shows 3 lines; "Read all" shows the rest (the words are never changed). */
  [].slice.call(document.querySelectorAll('.p8-q__t')).forEach(function (q, i) {
    if (q.scrollHeight <= q.clientHeight + 2) { return; }
    var fig = q.closest('.p8-q'), b = document.createElement('button');
    b.type = 'button'; b.className = 'p8-q__more'; b.textContent = 'Read all'; b.setAttribute('aria-expanded', 'false');
    q.id = q.id || 'p8-q-' + i; b.setAttribute('aria-controls', q.id);
    b.addEventListener('click', function () { var on = !fig.classList.contains('is-full'); fig.classList.toggle('is-full', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); b.textContent = on ? 'Show less' : 'Read all'; });
    q.parentNode.insertBefore(b, q.nextSibling);
  });
})();
(function () {
  var box = document.querySelector('[data-p8-chips]');
  if (!box) { return; }
  box.classList.add('p8-chips--js');
  var btns = [].slice.call(box.querySelectorAll('[data-p8-chip]'));
  function set(b, on) {
    b.setAttribute('aria-expanded', on ? 'true' : 'false');
    var p = document.getElementById(b.getAttribute('aria-controls'));
    if (p) { p.classList.toggle('is-open', on); }
  }
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-expanded') !== 'true';
      btns.forEach(function (x) { set(x, false); });
      set(b, on);
    });
  });
  box.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var o = btns.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
      if (o) { set(o, false); o.focus(); }
    }
  });
})();
